angular.module('picmonicng').factory('SpacedRepetitionDisclaimerModal', [
  '$modal',
  function ($modal) {
    return {
      show: function () {
        $modal.open({
          windowClass: 'spaced-repetition-disclaimer-modal',
          templateUrl:
            '/templates/app/factories/spaced-repetition-disclaimer-modal/spaced-repetition-disclaimer-modal.html',
        });
      },
    };
  },
]);
